import React, { useState } from "react";
import decryptCookieData from "./Functions/decryptCookieData";
import { toast } from 'react-toastify';
import { useEffect } from "react";

const Address = ({ data, setData, selectedBillingAddress, setSelectedShippingAddress, setSelectedBillingAddress, selectedShippingAddress }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isChangeOpen, setIsChangeOpen] = useState(false);
    const [newAddress, setNewAddress] = useState("");
    const [selectedAddressType, setSelectedAddressType] = useState("")
    const [city, setCity] = useState("")
    const [pincode, setPincode] = useState("")
    const [selectedAddress, setSelectedAddress] = useState("F/403 GEETA NAGAR, PHASE 7, MIRA ROAD EAST, THANE, MAHARASHTRA - 401107");
    const [load, setLoad] = useState(false);
    const [addressmain, setAddress] = useState([])
    // const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
    // const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    const [addressList, setAddressList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editingAddressId, setEditingAddressId] = useState(null);
    const [pincodes, setPincodes] = useState([])
    const urlmain = process.env.REACT_APP_API_URL

    const [changingFor, setChangingFor] = useState(""); // "shipping" or "billing"

    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    // Function to open modal
    const openModal = () => setIsModalOpen(true);
    const OpenChangeModal = () => setIsChangeOpen(true);

    // Function to close modal
    const closeModal = () => {
        setIsModalOpen(false);
        setIsEditing(false);
        setEditingAddressId(null);
    };

    const closeChangeModal = () => setIsChangeOpen(false);

    const handleAddressChange = (e) => {
        setNewAddress(e.target.value);
    };

    const saveAddressChange = () => {
        setNewAddress(selectedAddress); // Update the displayed address
        setIsChangeOpen(false); // Close modal
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const fetchData = async () => {
        try {
            const response = await fetch(`${urlmain}/pincode/getall/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res.pincodesData);
            setPincodes(res.pincodesData);
        } catch (error) {
            console.log(error);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);

        const method = isEditing ? "PUT" : "POST";
        const url = isEditing
            ? `${urlmain}/address/${editingAddressId}`
            : `${urlmain}/address`;

        try {
            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    location_user: data.location_user,
                    new_address: data.new_address,
                    city: data.city,
                    area: data.area,
                    pincode: data.pincode,
                    user_id: userData.user_id,
                    user_name: userData.full_name,
                }),
            });

            const result = await response.json();
            if (!result.isError) {
                toast.success(isEditing ? "Address updated successfully" : "Address added successfully", {
                    position: "top-center",
                    autoClose: 2000,
                });
                setIsModalOpen(false);
                setIsEditing(false);         // reset editing state
                setEditingAddressId(null);
                setLoad(false);
                fetchAddress();
            } else {
                toast.error(result.message || "Failed to save address");
                setLoad(false);
            }
        } catch (error) {
            toast.error("Error saving address");
            console.error("Save Error:", error);
            setLoad(false);
        }
    };


    // const fetchAddress = async () => {
    //     try {
    //         const res = await fetch(`${url}/address/${userData.user_id}`);
    //         const result = await res.json();
    //         console.log(result)
    //         if (!result.isError) {
    //             setAddressList(result.user);
    //             setSelectedShippingAddress(result.user[0] || null);
    //             setSelectedBillingAddress(result.user[1] || result.user[0] || null);
    //         }
    //     } catch (err) {
    //         console.error("Error fetching address", err);
    //     }
    // };

    const fetchAddress = async () => {
        try {
            const res = await fetch(`${urlmain}/address/${userData.user_id}`);
            const result = await res.json();
            if (!result.isError) {
                const addresses = result.user;
                setAddressList(addresses);

                // Set default addresses
                const defaultShipping = addresses.find(addr => addr.defaultaddressS);
                const defaultBilling = addresses.find(addr => addr.defaultaddressB);

                setSelectedShippingAddress(defaultShipping || addresses[0] || null);
                setSelectedBillingAddress(defaultBilling || addresses[0] || null);
            }
        } catch (err) {
            console.error("Error fetching address", err);
        }
    };


    const handleDeleteAddress = async (id) => {
        try {
            const confirmed = window.confirm("Are you sure you want to delete this address?");
            if (!confirmed) return;

            const res = await fetch(`${urlmain}/address/${id}`, {
                method: "DELETE",
            });

            const result = await res.json();
            if (!result.isError) {
                toast.success("Address deleted successfully!");
                fetchAddress();
            } else {
                toast.error("Failed to delete address.");
            }
        } catch (err) {
            toast.error("An error occurred while deleting.");
            console.error(err);
        }
    };


    const addresses = [
        "F/403 GEETA NAGAR, PHASE 7, MIRA ROAD EAST, THANE, MAHARASHTRA - 401107",
        "B/102 SUNFLOWER APARTMENT, MIRA ROAD EAST, THANE - 401105",
        "C/205 GREEN VIEW RESIDENCY, BORIVALI WEST, MUMBAI - 400092",
    ];

    const renderAddressCard = (type, selectedAddress) => {
        const isDefault =
            type === "shipping"
                ? selectedAddress?.defaultaddressS === true || selectedAddress?.defaultaddressS === "1"
                : selectedAddress?.defaultaddressB === true || selectedAddress?.defaultaddressB === "1";

        return (
            <div className="address-card">
                <h3>{type === "shipping" ? "Shipping Address" : "Billing Address"}</h3>

                {selectedAddress && isDefault ? (
                    <>
                        <p><strong>{selectedAddress.location_user}</strong></p>
                        <p>{`${selectedAddress.new_address}, ${selectedAddress.city} - ${selectedAddress.pincode}`}</p>
                    </>
                ) : (
                    <p>No {type} address selected</p>
                )}

                <div className="address-actions">
                    {addressList.length > 0 && (
                        <button onClick={() => {
                            setChangingFor(type);
                            setSelectedAddress(type === "shipping" ? selectedShippingAddress : selectedBillingAddress);
                            setIsChangeOpen(true);
                        }}>
                            Change
                        </button>
                    )}
                    <button onClick={() => setIsModalOpen(true)}>Add</button>
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (isModalOpen && window.google) {
            const input = document.getElementById("google-autocomplete");
            if (!input) return;

            const autocomplete = new window.google.maps.places.Autocomplete(input);

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (place && place.formatted_address) {
                    setData(prev => ({
                        ...prev,
                        area: place.formatted_address,
                    }));
                }
            });
        }
    }, [isModalOpen]);



    useEffect(() => {
        fetchAddress();
        fetchData();
    }, [])

    return (
        <>
            {/* <div className="address-card-section">
                <div className="address-card">
                    <h3>Shipping Address</h3>
                    <p className="address-type"><strong>Home</strong></p>
                    <p className="address-details">{newAddress || selectedAddress}</p>
                    <p className="address-mobile"><strong>Mobile:</strong> 9696421752</p>
                    <div className="address-actions">
                        <button onClick={OpenChangeModal}>Change</button> | <button onClick={openModal}>Add Address</button>
                    </div>
                </div>
                <div className="address-card">
                    <h3>Billing Address</h3>
                    {selectedAddress && selectedAddress.new_address ? (
                        <>
                            <p className="address-type"><strong>{selectedAddress.location_user || "Home"}</strong></p>
                            <p className="address-details">
                                {`${selectedAddress.new_address}, ${selectedAddress.city} - ${selectedAddress.pincode}`}
                            </p>
                            <p className="address-mobile"><strong>Mobile:</strong>9876543210</p>
                        </>
                    ) : (
                        <p className="no-address-text">No address selected</p>
                    )}

                    <div className="address-actions">
                        <button onClick={OpenChangeModal}>Change</button> | <button onClick={openModal}>Add Address</button>
                    </div>
                </div>
            </div> */}
            <div className="address-card-section">
                {renderAddressCard("shipping", selectedShippingAddress)}
                {renderAddressCard("billing", selectedBillingAddress)}

            </div>

            {isModalOpen && (
                <div className="address-overlay">
                    <div className="address-content">
                        <h3>Add Address</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="add-new-address-type-perfume">
                                <div className="add-new-address-radio-group-perfume">
                                    <label
                                        className={data.location_user === "Home" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Home
                                        <input type="radio" name="location_user" value="Home" checked={data.location_user === "Home"} readOnly />
                                    </label>

                                    <label
                                        className={data.location_user === "Office" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Office
                                        <input type="radio" name="location_user" value="Office" checked={data.location_user === "Office"} readOnly />
                                    </label>

                                    <label
                                        className={data.location_user === "Others" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Others
                                        <input type="radio" name="location_user" value="Others" checked={data.location_user === "Others"} readOnly />
                                    </label>
                                </div>
                            </div>
                            <div className="address-input-group">
                                <input
                                    type="text"
                                    id="google-autocomplete"
                                    className="address-input"
                                    placeholder="Enter Google address"
                                    autoComplete="off"

                                    onChange={(e) => setData(prev => ({ ...prev, area: e.target.value }))}
                                    value={data.area || ""}
                                />


                                <input
                                    type="text"
                                    name="new_address"
                                    className="address-input"
                                    placeholder="Enter Flat.no/Building Name/Street"
                                    value={data.new_address}
                                    onChange={handleChange}
                                />
                                <div className="address-city-pincode">
                                    <input
                                        type="text"
                                        name="city"
                                        className="city-input"
                                        placeholder="Enter new city"
                                        value={data.city}
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        className="pincode-input"
                                        name="pincode"
                                        placeholder="Enter new pincode"
                                        value={data.pincode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="address-modal-actions">
                                <button onClick={closeModal} className="address-close">Cancel</button>
                                {
                                    load ?
                                        <button type="button" className="address-save" disabled={load}>Loading...</button> :
                                        <button type="submit" className="address-save">Save</button>

                                }

                            </div>
                        </form>
                    </div>
                </div>
            )}


            {isChangeOpen && (
                <div className="address-overlay">
                    <div className="address-content address-change-options">
                        <h3>Select {changingFor === "shipping" ? "Shipping" : "Billing"} Address</h3>
                        {addressList.map((address, index) => (
                            <div key={index} className={`address-option-modal ${selectedAddress?.id === address.id ? 'selected' : ''}`}>
                                <label className="address-label-section">
                                    <input
                                        type="radio"
                                        name="address"
                                        value={address.new_address}
                                        checked={selectedAddress?.id === address.id}
                                        onChange={() => {
                                            if (changingFor === "shipping") {
                                                const isAllowed = pincodes.some((pin) => pin.pincode === address.pincode);
                                                console.log(pincodes, address)
                                                if (!isAllowed) {
                                                    toast.warning("Shipping not available for this pincode", {
                                                        position: "top-center",
                                                        autoClose: 2000,
                                                    });
                                                    return;
                                                }
                                            }
                                            setSelectedAddress(address);
                                        }}
                                        className="hidden-radio"
                                    />

                                    <div style={{ cursor: "pointer" }}>
                                        <strong>{address.location_user}</strong><br />
                                        {address.new_address}, {address.city} - {address.pincode}
                                    </div>
                                </label>

                                <div className="address-actions-inline">
                                    <button
                                        className={`edit-btn ${selectedAddress?.id === address.id ? 'buttonselected' : 'buttoncolor'}`}
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                location_user: address.location_user,
                                                new_address: address.new_address,
                                                city: address.city,
                                                pincode: address.pincode,
                                            });
                                            setEditingAddressId(address.id);      // Set the ID of address being edited
                                            setIsEditing(true);                   // Enable editing mode
                                            setIsModalOpen(true);
                                            setIsChangeOpen(false)            // Open the modal
                                        }}
                                    >
                                        <i className="fa-solid fa-pen"></i>
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() => handleDeleteAddress(address.id)}
                                    >
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        ))}


                        <div className="address-modal-actions">
                            <button onClick={closeChangeModal} className="address-close">Cancel</button>
                            {/* <button
                                onClick={() => {
                                    if (changingFor === "shipping") {
                                        setSelectedShippingAddress(selectedAddress);
                                    } else if (changingFor === "billing") {
                                        setSelectedBillingAddress(selectedAddress);
                                    }
                                    setIsChangeOpen(false); // ✅ close modal
                                }}
                                className="address-save"
                            >
                                Save
                            </button> */}
                            <button
                                onClick={async () => {
                                    if (!selectedAddress) {
                                        toast.warning("Please select an address before saving.");
                                        return;
                                    }

                                    if (changingFor === "shipping") {
                                        const isAllowed = pincodes.some(pin => String(pin.pincode) === String(selectedAddress.pincode));
                                        if (!isAllowed) {
                                            toast.warning("Shipping not available for this pincode", {
                                                position: "top-center",
                                                autoClose: 2000,
                                            });
                                            return;
                                        }
                                    }

                                    try {
                                        const fieldToUpdate =
                                            changingFor === "shipping" ? "defaultaddressS" : "defaultaddressB";

                                        // Reset previous default
                                        const resetResponse = await fetch(
                                            `${urlmain}/address/reset-default/${changingFor}/${userData.user_id}`,
                                            { method: "PATCH" }
                                        );

                                        // Set current as default
                                        const setResponse = await fetch(
                                            `${urlmain}/address/${selectedAddress.id}`,
                                            {
                                                method: "PATCH",
                                                headers: { "Content-Type": "application/json" },
                                                body: JSON.stringify({
                                                    [fieldToUpdate]: true,
                                                }),
                                            }
                                        );

                                        const setResult = await setResponse.json();

                                        if (!setResult.isError) {
                                            toast.success(`Default ${changingFor} address updated`);

                                            // Refetch and reselect updated default address
                                            const refreshed = await fetch(`${urlmain}/address/${userData.user_id}`);
                                            const refreshedData = await refreshed.json();
                                            const addresses = refreshedData.user;

                                            const newShipping = addresses.find(a => a.defaultaddressS);
                                            const newBilling = addresses.find(a => a.defaultaddressB);

                                            setAddressList(addresses);
                                            setSelectedShippingAddress(newShipping || addresses[0] || null);
                                            setSelectedBillingAddress(newBilling || addresses[0] || null);
                                            setIsChangeOpen(false);
                                        }

                                    } catch (error) {
                                        toast.error("An error occurred while setting default address");
                                        console.error(error);
                                    }
                                }}
                                className="address-save"
                            >
                                Save
                            </button>

                        </div>

                    </div>
                </div>
            )}
        </>
    )
}

export default Address;